module.exports = ["току-що",["преди %s секунда","преди %s секунди"],["преди %s минута","преди %s минути"],["преди %s час","преди %s часа"],["преди %s ден","преди %s дни"],["преди %s седмица","преди %s седмици"],["преди %s месец","преди %s месеца"],["преди %s година","преди %s години"]]


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-timeago/locales/bg-BG.json
// module id = 5Bkc
// module chunks = 1